import Vue from "vue";
import {VueReCaptcha} from "vue-recaptcha-v3";

// For more options see below
Vue.use(VueReCaptcha, {siteKey: "6Ldh7ZEfAAAAAJKwHNcuAQQJ74CLgUuadAL5iXeq"});
